'use client';

import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import styles from './primitives.module.css';

const buttonVariants = cva(styles.button, {
  variants: { variant: { default: styles.primary, outline: styles.outline, ghost: styles.ghost } },
  defaultVariants: { variant: 'default' },
});
export const Button = React.forwardRef(({ className, variant, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      ref={ref}
      className={buttonVariants({ variant, className })}
      {...(!asChild && { type: 'button' })}
      {...props}
    />
  );
});
Button.displayName = 'Button';
export const Card = React.forwardRef(({ className = '', ...props }, ref) => (
  <div ref={ref} className={`${styles.card} ${className}`} {...props} />
));
Card.displayName = 'Card';
